import React, { useEffect, useState, useMemo } from 'react';

import FilteringTable from './Table/FilteringTable/FilteringTable';
import ColumnFilter from './Table/FilteringTable/ColumnFilter';
import PageTitle from '../layouts/PageTitle';

import { tableColumnNamesNominationHistory } from '../../utils/tableColumnNamesNominationHistory';
import { tableRowsValuesNominationHistory } from '../../utils/tableRowsValuesNominationHistory';
import { arrayToFlatObject } from '../../utils/arrayToFlatObject';
import AdminNominationHistoryCell from './AdminNominationHistoryCell';

import { filteringTableGetTableColumns } from '../../utils/filteringTableGetTableColumns';
import { filteringTableFilterUniqueCandidates } from '../../utils/filteringTableFilterUniqueCandidates';
import { useStaticCollections } from '../../context/StaticCollections';
import { useAdminCollections } from '../../context/AdminCollections';

const AdminNominationHistory = () => {
  const {
    electionTypes,
    fellows,
    nominationHistoryArray,
    nominationStatusTypes,
    sectionalCommitteesWithCmse,
    isLoading: staticLoading,
  } = useStaticCollections();

  const {
    candidates,
    proposerSeconder,
    isLoading: adminLoading,
  } = useAdminCollections();

  const mergedData = useMemo(
    () => [...(nominationHistoryArray || [])],
    [nominationHistoryArray],
  );

  const [nominationsData, setNominationsData] = useState([]);
  const [nominationsColumns, setNominationsColumns] = useState([]);

  useEffect(() => {
    const tableColumns = filteringTableGetTableColumns(
      tableColumnNamesNominationHistory,
      ColumnFilter,
      AdminNominationHistoryCell,
    );

    const proposers = proposerSeconder
      ? proposerSeconder.map((item) => ({
          [item.attributes.nominationId]: item.attributes.proposerFellowId,
        }))
      : [];

    const proposerSeconderObj = arrayToFlatObject(proposers);

    const tableData = tableRowsValuesNominationHistory(
      mergedData,
      proposerSeconderObj,
      electionTypes,
      nominationStatusTypes,
      sectionalCommitteesWithCmse,
      fellows,
    );

    setNominationsColumns(tableColumns);

    const tableDataTwo = Object.values(tableData).map((nomination) => {
      if (candidates[nomination.candidateId] !== undefined) {
        nomination.candidate = candidates[nomination.candidateId];
      }

      return nomination;
    });

    const filteredData = filteringTableFilterUniqueCandidates(tableDataTwo);

    setNominationsData(filteredData);
  }, [
    electionTypes,
    nominationStatusTypes,
    sectionalCommitteesWithCmse,
    fellows,
    candidates,
    proposerSeconder,
    nominationHistoryArray,
    mergedData,
  ]);

  return (
    <>
      <PageTitle activeMenu="Nomination History" motherMenu="Home" />
      <FilteringTable
        componentName="AdminNominationHistory"
        columns={nominationsColumns}
        data={nominationsData}
        isLoading={staticLoading || adminLoading}
      />
    </>
  );
};

export default AdminNominationHistory;
